<template>
  <div>
    <Loading
      v-if="isLoading"
      is-loading
    />
    <template v-else>
      <h1 class="persona-view-header">
        Excuse us for jumping in... we have a quick question. Don’t worry, we won’t ask again.
      </h1>
      <h3>How would you best describe your role?</h3>
      <div
        class="persona-view-radio-group"
        role="radiogroup"
        :aria-label="'Select your default project view'"
      >
        <div
          v-for="(persona, index) in personasList"
          :key="`persona-view-option-${index}`"
          :ref="`persona-view-option-${index}`"
          class="persona-view__item"
          role="radio"
          :aria-checked="persona.value === selectedPersona"
          :class="{ 'persona-view__item--selected': persona.value === selectedPersona }"
          tabindex="0"
          :aria-label="persona.description"
          :data-identifier="persona.value"
          @click="onSelect(persona.value)"
          @keyup.enter="onSelect(persona.value)"
        >
          <div
            class="persona-view-icon-wrapper"
            :class="{ 'persona-view__item-text--selected' : persona.value === selectedPersona }"
          >
            <img
              class="persona-view__item-check"
              v-if="persona.value === selectedPersona"
              :src="checkIcon"
            >
            <img
              class="persona-view__item-icon"
              :src="persona.icon"
            >
            <label class="persona-view__item-text">{{ persona.label }}</label>
            <label class="persona-view__item-text-description">{{ persona.description }}</label>
          </div>
        </div>
      </div>
      <div
        class="error-message"
        v-if="errorMessage"
      >
        {{ errorMessage }}
      </div>
      <p class="persona-view-info">
        We use this information to personalize your
        experience, tailoring it to suit your needs perfectly.
      </p>
      <div class="persona-view__actions">
        <button
          class="w-button w-button--blue persona-view__submit"
          data-identifier="persona-submit"
          @click="onSubmit"
        >
          <span class="w-button__label">Next</span>
        </button>
      </div>
    </template>
  </div>
</template>
<script>
import axios from 'axios';

import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';
import TwSelect from '@/components/widgets/TwSelect.vue';
import ContributorPersona from '@/assets/images/contributor-persona.png';
import ProjectManagerPersona from '@/assets/images/pm-persona.png';
import OpsManagerPersona from '@/assets/images/ops-manager-persona.png';
import ClientPersona from '@/assets/images/client-persona.png';
import checkIcon from '@/assets/images/icon-check.svg';

export default {
  components: {
    PageHeader,
    Loading,
    TwSelect,
    ContributorPersona,
    ProjectManagerPersona,
    OpsManagerPersona,
    ClientPersona,
  },

  data() {
    return {
      checkIcon,
      isLoading: false,
      errorMessage: undefined,
      personasList: [
        {
          label: 'Individual contributor',
          value: 'contributor',
          icon: ContributorPersona,
          description: 'I deliver work assigned to me',
        },
        {
          label: 'Project manager',
          value: 'manager',
          icon: ProjectManagerPersona,
          description: 'I oversee the work of others',
        },
        {
          label: 'Operations Manager',
          value: 'ops-manager',
          icon: OpsManagerPersona,
          description: 'I optimize operational workflows',
        },
        {
          label: 'Client',
          value: 'client',
          icon: ClientPersona,
          description: 'I commission the project',
        },

      ],
      selectedPersona: null,
    };
  },

  methods: {
    onSelect(value) {
      this.selectedPersona = value;
    },
    async onSubmit() {
      if (!this.selectedPersona) {
        this.errorMessage = 'Please select a role';
        return;
      }

      this.isLoading = true;
      this.errorMessage = undefined;

      await axios.patch('/launchpad/v1/user/meta.json', { userPersona: this.selectedPersona })
        .then(() => {
          this.$emit('saved');
        })
        .catch((error) => {
          this.errorMessage = `Something went wrong. Please try again later. \n Details:  ${error}`;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  unmounted() {
    this.$store.commit('setFormState', '');
  },
};
</script>
<style lang="scss" scoped>
@import '../../../styles/variables/_variables.scss';


.persona-view-header {
  font-size: 20px;
  text-align: left;
  line-height: 26px;
  font-weight: 600;
  margin-bottom: 20px
}

.error-message {
  color: $color--error;
  margin-top: 12px;
}

.persona-view-radio-group {
    display: grid;
    grid-template-columns: 280px 280px;
    grid-row-gap: 16px;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
}

.persona-view__item {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .persona-view-icon-wrapper {
        border: 1px solid #C5CAE0;
        width: 262px;
        height: 214px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        position: relative;
    }

    .persona-view-icon-wrapper:hover {
      border-color: #64697D;
    }
}

.persona-view__item-icon {
  height: 115px;
  width: 115px;
}

.persona-view__item-check {
  position: absolute;
  top: 16px;
  right: 16px;
}

.persona-view__item-text {
    margin-top: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.persona-view__item-text-description {
      margin-top: 3px;
      font-weight: 400;
      cursor: pointer;
    }

.persona-view__item-text--selected {
    color: #4461D7;
}

.persona-view__actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.persona-view__submit {
  border-radius: 50px;
  width: 80px;
}

.persona-view-info {
  font-size: 12px;
  margin-top: 12px;
}

.persona-view__item--selected {
    .persona-view-icon {
        fill: #4461D7;
    }

    .persona-view-icon-wrapper {
        border-color: #4461D7 !important;
        background-color: #F2F4FC;
    }
}
</style>



// WEBPACK FOOTER //
// PersonaCapture.vue?4a77f3f2